import n2words from 'n2words'

import ingetPrintLogo from '@/assets/pics/ingetPrint.png'
import pipsPrintStamp from '@/assets/pics/print.png'
import ingetPrintStamp from '@/assets/pics/printInget.png'
import pipsPrintLogo from '@/assets/pics/printLogo.png'
import type { OrderProductModel } from '@/types'
import { getVatAmount } from '@/utils/price/vat'

export type InvoiceType = 'CLIENT' | 'RRC' | 'RRC_HIDDEN'

export const INVOICE_VALIDITY_TEXT =
  'Срок действия счета составляет 3 (три) банковских дня с даты его выставления'

export const formatInvoiceIssueDate = (date: Date) =>
  date.toLocaleDateString('ru-RU')

export const isRrcInvoice = (type: InvoiceType) => type !== 'CLIENT'

export const formatInvoiceQuantity = (value: number) =>
  value
    .toFixed(4)
    .replace(/\.?0+$/, '')
    .replace('.', ',')

export const formatInvoiceMoney = (value: number) => value.toFixed(2)

export const formatInvoiceDeliveryTime = (
  etaMaxDays: number | null | undefined
) => {
  if (etaMaxDays === null || etaMaxDays === undefined || etaMaxDays === 0) {
    return 'В наличии'
  }

  const lastTwoDigits = etaMaxDays % 100
  const lastDigit = etaMaxDays % 10
  const unit =
    lastTwoDigits >= 11 && lastTwoDigits <= 14
      ? 'дней'
      : lastDigit === 1
        ? 'день'
        : lastDigit >= 2 && lastDigit <= 4
          ? 'дня'
          : 'дней'

  return `${etaMaxDays} ${unit}`
}

export const formatInvoiceProductName = (
  article: string | null | undefined,
  description: string | null | undefined,
  type: InvoiceType
) => {
  const originalArticle = article || ''
  const visibleArticle =
    type === 'RRC_HIDDEN' && originalArticle.length > 2
      ? `${originalArticle[0]}${'*'.repeat(originalArticle.length - 2)}${originalArticle.at(-1)}`
      : originalArticle
  const visibleDescription =
    type === 'RRC_HIDDEN'
      ? (description || '').replace(/\d/g, '*')
      : description || ''

  return visibleArticle
    ? `${visibleArticle}, ${visibleDescription}`
    : visibleDescription
}

export const getPrintLogo = () => {
  const hostname = window.location.hostname
  if (hostname.includes('inget.by')) return ingetPrintLogo
  return pipsPrintLogo
}

export const getPrintStamp = () => {
  const hostname = window.location.hostname
  if (hostname.includes('inget.by')) return ingetPrintStamp
  return pipsPrintStamp
}

function declension(num: number, words: [string, string, string]): string {
  const value = Math.abs(num) % 100
  const n = value % 10

  if (value > 10 && value < 20) return words[2]
  if (n > 1 && n < 5) return words[1]
  if (n === 1) return words[0]
  return words[2]
}

export function numberToWordsRu(n: number): string {
  const [intPart, fracPart] = n.toFixed(2).split('.')

  const rubles = parseInt(intPart, 10)
  const kopecks = parseInt(fracPart, 10)

  const rublesWords = n2words(rubles, { lang: 'ru' })

  const rublesDecl = declension(rubles, ['рубль', 'рубля', 'рублей'])
  const kopecksDecl = declension(kopecks, ['копейка', 'копейки', 'копеек'])

  const result = rublesWords.charAt(0).toUpperCase() + rublesWords.slice(1)

  return `${result} ${rublesDecl} ${fracPart} ${kopecksDecl}`
}

export const getItemPricing = (
  item: Pick<
    OrderProductModel,
    'quantity' | 'retailPrice' | 'price' | 'amount' | 'vatAmount' | 'total'
  >,
  type: InvoiceType
) => {
  const isRRC = isRrcInvoice(type)
  const quantity = item.quantity || 0

  if (isRRC) {
    const price = item.retailPrice || 0
    const amount = price * quantity
    const vatAmount = getVatAmount(amount)
    const total = amount + vatAmount
    return { price, amount, vatAmount, total }
  } else {
    return {
      price: item.price || 0,
      amount: item.amount || 0,
      vatAmount: item.vatAmount || 0,
      total: item.total || 0,
    }
  }
}
